import React from "react";
import "../ComponentsCSS/Form.css";
import { Link } from "react-router-dom";

const Form = () => {
  return (
    <div className="contacts" data-aos="slide-up">
      <div className="container">
        <div className="row align-items-start text-center">

          {/* Left Side Content */}
          <div className="Content col-lg-12 col-sm-12 col-md-12 mb-4" data-aos="zoom-in">
            <h1>Book Your Service Now</h1>
            <p className="Contact-des">
              Book your service now with SASK A One Shuttle — where comfort meets
              reliability. Leave a Message If You Have a question.
            </p>
            <div className="contact-info">
              <h2>Email</h2>
              <Link to="#">admin@saskaoneshuttle.com</Link>
              <h2>Phone</h2>
              <a href="tel:+16394702917">+1 (639) 470-2917</a>
              <a href="tel:+13064916375">+1 (306) 491-6375</a>

              <h2>Fax Number</h2>
              <Link to="#">1 306-500-9618</Link>
              <h2>Address</h2>
              <Link to="#">#2-75 South Industrial Drive,
Prince Albert, SK. S6V 7L7, Ca</Link>
            </div>
          </div>

          {/* Right Side Content */}
          {/* <div className="contact-form col-lg-6 col-md-12" data-aos="zoom-in">
            <h1>Write a Message to Our Experts</h1>
            <label htmlFor="name">Name</label>
            <input type="text" id="name" plSASKholder="Enter Your Full Name" />

            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              plSASKholder="Enter Your Email Address"
            />

            <label htmlFor="phone">Phone</label>
            <input
              type="tel"
              id="phone"
              plSASKholder="Enter Your Phone Number"
            />

            <label htmlFor="message">Leave Us a Message</label>
            <textarea
              rows={7}
              id="message"
              plSASKholder="Type Your Message here......"
            ></textarea>

            <Link to="#">
              <button type="submit">Submit</button>
            </Link>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default Form;
